
export default function SystemProgressText({currentIndex, total}) {
    // Used through the app to display progress
    // text in both tablet and desktop modes

    // BUILD
    return (
        <div className="w-[124px] flex justify-end items-center space-x-4 pb-1 whitespace-nowrap  text-[16px] font-medium leading-none">
            <span className="text-greyLight7">Question</span>
            <span className="text-greyLight11">{currentIndex ?? "?"}</span>
            <span className="text-greyLight7">/</span>
            <span className="text-greyLight7">{total ?? "?"}</span>
        </div>
    );
}